import { IconProps } from './types';

export const PiggyIcon = ({ title = 'Piggy Icon', ...props }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" fill="none" viewBox="0 0 42 42" {...props}>
        <title>{title}</title>
        <path
            fill="#0A2F73"
            d="M9.625 9.112v6.445c-1.926 1.73-3.324 3.9-3.972 6.318H.875A.875.875 0 0 0 0 22.75v7c0 .483.392.875.875.875h5.823c.908 1.691 2.21 3.194 3.802 4.422v6.078c0 .483.392.875.875.875h5.25a.875.875 0 0 0 .875-.875v-2.961c1.126.22 2.297.336 3.5.336s2.374-.116 3.5-.336v2.961c0 .483.392.875.875.875h5.25a.875.875 0 0 0 .875-.875v-6.078c3.222-2.484 5.25-6.093 5.25-10.11 0-7.49-7.052-13.562-15.75-13.562-2.12 0-4.14.36-5.986 1.014l-3.895-3.895c-.551-.552-1.494-.161-1.494.618"
        ></path>
        <path
            fill="#fff"
            fillRule="evenodd"
            d="M21 14.875c-.85 0-1.68.071-2.48.207a.875.875 0 0 1-.291-1.726 16.6 16.6 0 0 1 2.77-.231c1.969 0 3.846.342 5.55.963.694.253 1.36.551 1.99.892a.875.875 0 1 1-.83 1.54q-.835-.451-1.758-.788A14.5 14.5 0 0 0 21 14.875M9.625 20.563c.483 0 .875.391.875.875a2.187 2.187 0 1 0 4.375 0 .875.875 0 0 1 1.75 0 3.938 3.938 0 1 1-7.875 0c0-.484.392-.875.875-.875"
            clipRule="evenodd"
        ></path>
        <path
            fill="#0A2F73"
            fillRule="evenodd"
            d="M41.125 17.5c.483 0 .875.392.875.875a7.875 7.875 0 0 1-7.875 7.875.875.875 0 0 1 0-1.75 6.125 6.125 0 0 0 6.125-6.125c0-.483.392-.875.875-.875"
            clipRule="evenodd"
        ></path>
        <path
            fill="#D9DBDD"
            d="M31.244 1.494A.875.875 0 0 0 30.006.256l-3.5 3.5a.875.875 0 0 0 1.238 1.238zM35.619 2.369A.875.875 0 0 0 34.38 1.13l-5.25 5.25A.875.875 0 0 0 30.37 7.62z"
        ></path>
        <path fill="#FB0" d="M28 10.5a4.375 4.375 0 1 1-8.75 0 4.375 4.375 0 0 1 8.75 0"></path>
    </svg>
);
